import { useEffect } from 'react';
import { useHandHistory } from 'hooks/useHandHistory';

import { canRevealOwnCards } from './handSummary';
import { HandHistorySnapshot } from './types';

/**
 * Ask the socket for the viewer's own hole cards for this hand when the shared
 * document does not carry them. The card header shows "your cards" on every
 * collapsed row, so this runs for every card in the list, not only the one
 * that is open. The context ignores hands it already has and the recovery
 * module bounds retries (three attempts per hand), so the cost is at most one
 * request per hand in the 20-hand document.
 */
export const useOwnCardsRecovery = (hand: HandHistorySnapshot) => {
  const { revealOwnCards } = useHandHistory();
  const viewerSeat = hand.tableSnapshot.viewerSeat;
  const seats = hand.tableSnapshot.seats;

  useEffect(() => {
    if (!canRevealOwnCards(viewerSeat, seats)) return;
    revealOwnCards(hand.gameNo, hand.completedAt);
  }, [hand.completedAt, hand.gameNo, revealOwnCards, seats, viewerSeat]);
};
